<template>
  <base-box
    v-if="hasMessage || hasErrors"
    v-bind="$props"
    border-color="red"
    v-on="$listeners"
  >
    <template #content>
      <g-media-object>
        <template #left>
          <g-icon name="exclamation-circle" class="error" />
        </template>
        <template>
          <g-typography v-if="hasMessage" tag="p" :value="message" />
          <g-typography
            v-for="error in errors"
            :key="getErrorKey(error)"
            v-else-if="hasErrors"
            tag="p"
            :value="firstError(error)"
          />
        </template>
      </g-media-object>
    </template>
  </base-box>
</template>

<script>
  import first from 'lodash/first';
  import isEmpty from 'lodash/isEmpty';
  import get from 'lodash/get';
  import id from 'lodash/uniqueId'

  export default {
    name: 'ErrorMessageCard',
    props: {
      message: {
        type: String,
        default: ''
      },
      errors: {
        type: [Object, Array],
        default: () => ({})
      }
    },
    computed: {
      hasMessage() {
        return !isEmpty(this.message);
      },
      hasErrors() {
        return !isEmpty(this.errors);
      }
    },
    methods: {
      firstError(error) {
        return first(error);
      },
      getErrorKey(error) {
        return get(Array.isArray(error) ? first(error) : error, 'name', id('error-'))
      }
    }
  };
</script>

<style lang="scss" scoped>
  .error {
    color: $g-font-color-error;
  }
</style>
